export default "__VITE_ASSET__a2ce58a7__"